import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let frontmatter = {
  "title": "0.3.1-beta",
  "description": "Navegación móvil personalizable, mejoras grandes de pedidos y caja, combos rediseñados con stock automático, wizard de creación de productos, accesibilidad con tamaño de texto configurable, aviso de nueva versión, Faki crea y edita combos, centro de documentación con asistente IA, tour guiado por rol y arreglos de QA."
};
export let structuredData = {
  "contents": [{
    "heading": "resumen",
    "content": "Esta versión está enfocada en hacer Orkestria más cómodo en celular, más rápido para operar y más fácil de aprender. También estrenamos el centro de documentación que estás leyendo, con un asistente Faki integrado, una guía interactiva por rol y bastantes pulidos de QA."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Nueva barra inferior** con tus 4 accesos directos favoritos siempre a la mano."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Personaliza tus accesos directos** desde `Perfil → Preferencias UI` o manteniendo presionado el botón `Más`."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Atajos agrupados**: el botón `Tomar pedido` despliega opciones para mesa o domicilio. El botón `Cobrar` también despliega opciones según el tipo de orden."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Tus preferencias te siguen entre dispositivos**: si cambias de celular o de computador, tu configuración se conserva."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Tres modos de navegación móvil**: barra inferior, menú hamburguesa, o ambos al mismo tiempo (por defecto)."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Cierra el menú deslizando hacia abajo** con un gesto natural."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Búsqueda en el menú** con botón para borrar lo escrito de un toque."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Vuelve arriba automáticamente** cuando cambias de sección."
  }, {
    "heading": "navegación-en-celular",
    "content": "**El footer ya no queda tapado** por la barra inferior al hacer scroll hasta el final en celular."
  }, {
    "heading": "arrastrar-y-soltar",
    "content": "**Más cómodo de usar en celular**: el sistema espera un instante antes de empezar a arrastrar, así no interrumpe el scroll normal."
  }, {
    "heading": "arrastrar-y-soltar",
    "content": "**El elemento que arrastras sigue tu dedo con precisión**, sin desfasarse."
  }, {
    "heading": "arrastrar-y-soltar",
    "content": "**Scroll automático** cuando arrastras hacia los bordes de la pantalla, incluso entre paneles distintos (por ejemplo, al asignar productos a días en el horario semanal)."
  }, {
    "heading": "arrastrar-y-soltar",
    "content": "**Sin selección de texto accidental** al mantener presionado un elemento."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Comensales por grupo**: al iniciar una segunda ronda, el contador ya no se vuelve a sumar. Cada grupo de la mesa lleva su propio número de comensales."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Controles rápidos de comensales** con botones `−` y `+`, y un indicador en formato `{seleccionados}/{disponibles}`, restando los asientos ocupados por otros grupos."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Cambio fluido entre grupos**: al elegir un grupo existente, se restauran sus comensales; al crear un grupo nuevo, el contador arranca limpio."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Los descuentos del día se aplican correctamente** al agregar productos a una orden."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Cliente \"Nuevo cliente\" directo en el selector**: al tomar pedido, tomar domicilio o cobrar, ya no tienes que cambiar de sección para registrar un cliente nuevo. Lo creas en un modal rápido y queda seleccionado automáticamente."
  }, {
    "heading": "corregir-pedido",
    "content": "**Rondas separadas por grupo**: cuando una mesa tiene varios grupos, las rondas se cuentan dentro de cada grupo, no en una sola lista."
  }, {
    "heading": "corregir-pedido",
    "content": "**Selector de grupo tipo pestaña** arriba del listado para alternar entre los grupos activos de la mesa."
  }, {
    "heading": "corregir-pedido",
    "content": "**Indicador de qué grupo estás viendo** (\"Mostrando Grupo X · N rondas · M comensales\") para que no haya duda."
  }, {
    "heading": "corregir-pedido",
    "content": "**Puedes volver a aumentar la cantidad de un producto desde cero** cuando corriges una orden."
  }, {
    "heading": "corregir-pedido",
    "content": "**Aviso a cocina al corregir un pedido**: si modificas un producto que va a cocina, el chef se entera."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**No se puede cerrar la mesa hasta que todas las rondas estén entregadas**: incluso si se hizo precobro, el sistema espera a que cocina + mesero terminen para evitar cobrar comida que no llegó."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**Pre-cobro a crédito ahora cierra correctamente**: al confirmar el cierre, la deuda queda registrada en la cuenta del cliente automáticamente."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**Selector \"Nuevo cliente\" inline** en `Cobrar orden` y `Cobrar domicilio`, tanto al asignar cliente a la orden como al cargar a cuenta de crédito."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**Facturación de grupos separada**: al cobrar mesas con varios grupos, cada grupo genera su propia factura/visita en `Órdenes completadas`. Antes se mezclaban los pedidos en una sola factura."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**Cobro mixto de grupos en la misma mesa**: ya puedes cobrar un grupo a crédito y otro con tarjeta/efectivo sin que el sistema confunda los grupos. Los grupos ya cargados a crédito dejan de bloquear el cobro de los grupos restantes."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Adiciones y observaciones con cargo aparecen en factura, ticket y correo**: cada extra que el cliente pidió (queso adicional, salsas, etc.) y las observaciones con costo se muestran como sub-líneas indentadas debajo del producto base. Ahora la suma de líneas coincide con el total cobrado."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Métodos de pago con etiquetas claras**: ya no se muestra `credit` ni `mixed` en inglés. Se ve \"A cuenta del cliente\" y \"Pago mixto\" en facturas, tickets y correos."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Pago mixto desglosado**: cuando un cobro se divide en dos métodos (ej. parte efectivo + parte tarjeta), la factura y el correo muestran cada método con su monto. Antes el correo enviaba un código de programación crudo."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Correo de factura completo**: cuando una visita tiene varias rondas, el correo enviado al cliente incluye TODAS las rondas como una sola factura combinada. Antes solo se enviaba la primera ronda."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Rondas separadas visualmente en factura combinada**: cuando una visita tiene varias rondas, la factura, el ticket térmico y el correo muestran un encabezado \"Ronda N · fecha/hora\" antes de los productos de cada una. Así se distingue claramente qué se pidió en cada momento."
  }, {
    "heading": "productos",
    "content": "**Acciones del producto agrupadas** en un solo botón con menú: editar, programar días, gestionar adiciones, eliminar y más, sin saturar la fila."
  }, {
    "heading": "productos",
    "content": "**Aviso visual de stock bajo o agotado** directamente en la lista."
  }, {
    "heading": "productos",
    "content": "**Adiciones** se refresca al instante después de crearlas o editarlas (antes había que recargar)."
  }, {
    "heading": "wizard-de-creación--edición-en-3-pasos",
    "content": "**Nuevo flujo en 3 pasos** con barra de progreso visible:"
  }, {
    "heading": "wizard-de-creación--edición-en-3-pasos",
    "content": "**Información**: datos del producto (Tipo, Modo, nombre, precio, etc.)."
  }, {
    "heading": "wizard-de-creación--edición-en-3-pasos",
    "content": "**Combo**: selección de componentes — solo aparece si el tipo es \"Combo\"."
  }, {
    "heading": "wizard-de-creación--edición-en-3-pasos",
    "content": "**Multimedia**: galería de imágenes y videos."
  }, {
    "heading": "wizard-de-creación--edición-en-3-pasos",
    "content": "**El paso 2 se omite automáticamente** para productos individuales."
  }, {
    "heading": "wizard-de-creación--edición-en-3-pasos",
    "content": "**Botón \"Crear producto\" / \"Guardar cambios\" deshabilitado** hasta completar todos los pasos válidos (campos requeridos + ≥1 componente si es combo). Ya no es posible enviar formularios incompletos."
  }, {
    "heading": "wizard-de-creación--edición-en-3-pasos",
    "content": "**Navegación libre hacia atrás** para corregir cualquier paso."
  }, {
    "heading": "tipo-y-modo-dos-selectores-independientes",
    "content": "El selector único \"Tipo\" se separa en **dos campos**:"
  }, {
    "heading": "tipo-y-modo-dos-selectores-independientes",
    "content": "**Tipo**: `Producto` / `Combo` — define si se compone de otros productos o no."
  }, {
    "heading": "tipo-y-modo-dos-selectores-independientes",
    "content": "**Modo**: `Preparado` / `Bajo pedido` — define si requiere pasar por cocina."
  }, {
    "heading": "tipo-y-modo-dos-selectores-independientes",
    "content": "**Los combos también pueden ser \"bajo pedido\"**: antes los combos siempre se trataban como preparados."
  }, {
    "heading": "tipo-y-modo-dos-selectores-independientes",
    "content": "**El enrutamiento a cocina** ahora considera el modo del combo + el modo de cada componente: si alguno requiere cocina, la orden pasa por cocina."
  }, {
    "heading": "combos-rediseñados",
    "content": "**El combo se compone de otros productos**: al crearlo defines qué productos lo integran y cuántas unidades de cada uno. Antes el combo era un producto suelto sin componentes reales."
  }, {
    "heading": "combos-rediseñados",
    "content": "**Stock automático y en cascada**: el stock del combo se calcula a partir del stock de sus componentes. Por ejemplo, si un combo lleva 2× Hamburguesa y quedan 10 hamburguesas, el combo \"Alcanza para 5\"."
  }, {
    "heading": "combos-rediseñados",
    "content": "**Al pedir un combo se descuenta a los componentes**, no al combo. Si un mismo producto está en un combo y también como producto suelto en la misma orden, se suma y valida una sola vez contra el stock real."
  }, {
    "heading": "combos-rediseñados",
    "content": "**Sin anidación**: un combo no puede contener a otro combo (mantiene la lógica clara)."
  }, {
    "heading": "combos-rediseñados",
    "content": "**No se puede crear un combo vacío**: el sistema te exige al menos un componente antes de guardar."
  }, {
    "heading": "combos-rediseñados",
    "content": "**Restauración al cancelar**: si una orden con combos se cancela, los componentes recuperan su stock correctamente (antes solo se restauraba el combo)."
  }, {
    "heading": "combos-rediseñados",
    "content": "**Badge \"Combo\"** visible en la carta digital junto al nombre, con prioridad `Agotado > Combo > Popular`."
  }, {
    "heading": "combos-rediseñados",
    "content": "**Composición visible en la carta**: debajo de la descripción se lista \"Incluye: 2× Hamburguesa, 1× Papas, 1× Bebida\". La vista de detalle muestra una sección dedicada \"Este combo incluye\"."
  }, {
    "heading": "combos-rediseñados",
    "content": "**Agotado de combo automático**: si un componente con control de stock se acaba, el combo aparece como \"Agotado\" sin acción manual."
  }, {
    "heading": "productos-sin-categoría",
    "content": "**Ya no se publican en la carta digital**. Esta sección queda como espacio interno para borradores u organización temporal."
  }, {
    "heading": "productos-sin-categoría",
    "content": "**Aviso visual en el dashboard**: la sección \"Sin categoría\" del constructor de menú muestra una etiqueta \"No se muestra en la carta\" para evitar confusión."
  }, {
    "heading": "productos-sin-categoría",
    "content": "**Para publicar un producto** debes asignarle una categoría existente o crear una nueva."
  }, {
    "heading": "reservas",
    "content": "**Los meseros ya pueden arrastrar reservas** entre días, no solo dueños y administradores."
  }, {
    "heading": "reservas",
    "content": "**\"Nuevo cliente\" inline** también disponible al editar una reserva, para no salir del flujo."
  }, {
    "heading": "carta-digital",
    "content": "**Vista previa instantánea** al activar la carta: ya no hay que esperar a que el caché se renueve para verla."
  }, {
    "heading": "carta-digital",
    "content": "**Recomendaciones visibles** al subir el banner (relación 21:9, resolución sugerida, formatos, tamaño máximo) para evitar imágenes mal recortadas."
  }, {
    "heading": "carta-digital",
    "content": "**Código QR con el logo Orkestria al centro**, ahora visible en todos los temas."
  }, {
    "heading": "mesas",
    "content": "**Crear o cambiar de zona** desde el formulario ya no cierra el modal por accidente al interactuar con el selector."
  }, {
    "heading": "permisos-y-roles",
    "content": "**Meseros pueden crear clientes** directamente desde la lista o desde el selector inline en pedidos/reservas."
  }, {
    "heading": "permisos-y-roles",
    "content": "**Dueño sin restricciones**: arreglado el caso en que un dueño no podía abrir caja, eliminar invitaciones u operar acciones administrativas porque el sistema no lo reconocía como miembro de su propio restaurante. Ahora se le asigna automáticamente como dueño en el primer acceso."
  }, {
    "heading": "modales",
    "content": "**Modales más cómodos en celular**: el contenido largo ahora puede desplazarse sin romper el diseño."
  }, {
    "heading": "modales",
    "content": "**El fondo del modal bloquea correctamente** la interacción con la página detrás; ya no se puede hacer scroll por accidente."
  }, {
    "heading": "modales",
    "content": "**Los menús desplegables dentro de un modal** (selectores, combobox, etc.) ya no lo cierran al hacer clic dentro."
  }, {
    "heading": "modales",
    "content": "**El menú hamburguesa no abre el teclado** al abrirse."
  }, {
    "heading": "accesibilidad-y-legibilidad",
    "content": "**Nuevo ajuste de tamaño de texto**: si el texto te parece pequeño, puedes elegir entre 4 tamaños — Compacto, Normal, Grande y Extra grande — y todo el dashboard escala de manera proporcional (texto, botones, espaciados)."
  }, {
    "heading": "accesibilidad-y-legibilidad",
    "content": "**Wizard de bienvenida**: la primera vez que entras al dashboard, Orkestria te pregunta qué tamaño de texto prefieres con una vista previa en vivo. Después no vuelve a aparecer."
  }, {
    "heading": "accesibilidad-y-legibilidad",
    "content": "**Cámbialo cuando quieras** desde `Perfil → Preferencias UI → Legibilidad`. Tu elección queda guardada y te sigue entre dispositivos."
  }, {
    "heading": "accesibilidad-y-legibilidad",
    "content": "**Vista previa en vivo**: mientras eliges, ves un ejemplo real de cómo quedará la interfaz (nombre de producto, descripción, stock, botón), así sabes lo que estás aplicando antes de confirmar."
  }, {
    "heading": "accesibilidad-y-legibilidad",
    "content": "**Pestaña dedicada en perfil*&#x2A;: la sección antes llamada \"Preferencias UI\" ahora se llama &#x2A;*\"Accesibilidad e interfaz\"** para que sea fácil de encontrar."
  }, {
    "heading": "accesibilidad-y-legibilidad",
    "content": "**Encabezados del menú lateral más claros**: los títulos de grupo (MENÚ, CAJA, etc.) tienen tamaño fijo y un separador superior, así no se confunden con las pestañas — sobre todo cuando usas tamaños de texto grandes."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**En celular, el chat se hace pequeño cuando Faki te muestra un resultado**, para que veas lo que hizo."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**El botón flotante de Faki ya no tapa la barra inferior**."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**La guía visual se cancela automáticamente** si te vas a otra sección de la app durante el proceso. Antes Faki seguía intentando avanzar sobre la pantalla nueva."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**Faki ya sabe crear combos**: puedes pedirle \"crea un combo X con 2 hamburguesas y 1 papas\" y Faki lo arma con los componentes existentes. Si falta info, te la pregunta antes de invocar. Antes solo sabía crear productos individuales."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**Editar componentes de un combo desde el chat**: nueva acción `setComboItems` permite a Faki cambiar, añadir o quitar productos de un combo ya creado, conservando todas las validaciones (mínimo 1 componente, sin combos anidados, sin auto-referencia)."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**Modo de preparación independiente del tipo**: Faki ahora distingue claramente entre \"producto vs combo\" y \"preparado vs bajo pedido\". Puede crear un combo que requiera cocina, o uno listo para servir, según le pidas."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**Fix de bucle infinito al marcar tareas**: ocasionalmente Faki entraba en un loop intentando marcar una tarea con un ID que no existía en su lista — el sistema decía \"✓\" en verde pero la tarea no avanzaba. Ahora si el ID no existe, Faki lo sabe al instante y corrige sin reintentar."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**Faki conoce el menú completo en una sola llamada**: nueva acción `listMenu` devuelve todas las categorías + productos de un restaurante en una operación. Antes Faki buscaba producto por producto con `searchProduct`, lo que era lento y propenso a duplicados. Ahora cuando le pides crear un menú o auditar el catálogo, primero ve qué existe y evita duplicar."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**Faki no repite lecturas innecesarias**: cuando Faki emite varias veces la misma consulta (ej. dos `listMenu` con los mismos argumentos en la misma respuesta), el sistema deduplica antes de ejecutar — verás una sola tarjeta de actividad en el chat en lugar de varias. Si Faki insiste, tras 3 intentos recibe un STOP forzoso para que avance con lo que ya tiene."
  }, {
    "heading": "aviso-de-nueva-versión",
    "content": "**Modal \"Qué hay de nuevo\"**: cuando se actualiza Orkestria, te aparece una sola vez un aviso con un resumen del cambio y un botón **Ver cambios** que te lleva directo al changelog."
  }, {
    "heading": "aviso-de-nueva-versión",
    "content": "**Una vez por versión, por usuario**: lo cierras una vez y ya no vuelve a aparecer hasta la próxima release."
  }, {
    "heading": "aviso-de-nueva-versión",
    "content": "**Usuarios nuevos no se molestan**: si entras por primera vez, solo ves el wizard de accesibilidad — el aviso de versión se omite para no acumular interrupciones."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Sección dedicada en `/docs`** con changelogs y manual de usuario, accesible para todos (no requiere iniciar sesión)."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Accesos desde toda la plataforma**: enlace en el landing, footer y dentro del dashboard."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Selector de versiones** para ver el detalle completo de cada release."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Cambio de tema dentro de docs** (claro, azul oscuro, noche): se sincroniza con el resto de la plataforma."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Asistente Faki integrado en docs**:"
  }, {
    "heading": "centro-de-documentación",
    "content": "**Conoce toda la documentación** y responde tus dudas en español con Markdown (negritas, listas, secciones)."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Page-agent**: te lleva al lugar exacto de la respuesta. Resalta la sección concreta con un anillo visual."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Dos modos**: flotante (sobre el contenido) o inmersivo (empuja el contenido a un lado, configurable y redimensionable)."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Abierto por defecto** en computador, cerrado por defecto en celular."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Límite por dispositivo**: 10 consultas al día, sin afectar tu cuota de Faki en el resto de la app."
  }, {
    "heading": "tour-guiado-por-rol",
    "content": "**Primera vez que entras a un restaurante con un rol nuevo**: Faki te ofrece una guía rápida con paso a paso interactivo (resaltado, tooltips, navegación entre pestañas)."
  }, {
    "heading": "tour-guiado-por-rol",
    "content": "**Por rol**: dueño, administrador, mesero, chef, cajero, encargado de domicilios y encargado de inventario tienen tours adaptados a lo esencial de su trabajo."
  }, {
    "heading": "tour-guiado-por-rol",
    "content": "**Se muestra una sola vez por rol**, aunque pertenezcas a varios restaurantes."
  }, {
    "heading": "tour-guiado-por-rol",
    "content": "**Si lo saltas, no vuelve a aparecer**, pero siempre puedes preguntarle a Faki para repasarlo."
  }, {
    "heading": "temas",
    "content": "**Tema noche corregido en facturación** y otras zonas que se veían en blanco sobre blanco."
  }, {
    "heading": "temas",
    "content": "**El cambio de tema se sincroniza** entre el landing, la app y el centro de documentación."
  }, {
    "heading": "otros",
    "content": "**Video del landing** ya no se solapa con la barra superior en celular."
  }, {
    "heading": "otros",
    "content": "**Programar días de disponibilidad** de un producto desde su menú de acciones."
  }, {
    "heading": "otros",
    "content": "**Acceso desde red local**: la app se puede probar desde otro dispositivo en la misma red sin configurar nada extra."
  }, {
    "heading": "otros",
    "content": "**Redirección automática al expirar la sesión**: si el token caduca mientras usas el dashboard, te enviamos al login con un aviso \"Tu sesión expiró\". Antes solo aparecía un error 401 silencioso."
  }, {
    "heading": "otros",
    "content": "**Vuelta al inicio en navegación interna**: cuando un tab tiene flujo en pasos (cobrar mesa, cobrar domicilio, corregir pedido, tomar pedido, tomar domicilio, sesiones de caja, órdenes completadas, cuentas de crédito), al avanzar o retroceder de pantalla la página vuelve arriba automáticamente. Antes quedabas mirando el footer y daba sensación de estar perdido."
  }],
  "headings": [{
    "id": "resumen",
    "content": "Resumen"
  }, {
    "id": "navegación-en-celular",
    "content": "Navegación en celular"
  }, {
    "id": "arrastrar-y-soltar",
    "content": "Arrastrar y soltar"
  }, {
    "id": "pedidos-en-mesa",
    "content": "Pedidos en mesa"
  }, {
    "id": "corregir-pedido",
    "content": "Corregir pedido"
  }, {
    "id": "caja-y-crédito-fiado",
    "content": "Caja y crédito (fiado)"
  }, {
    "id": "facturación-y-tickets",
    "content": "Facturación y tickets"
  }, {
    "id": "productos",
    "content": "Productos"
  }, {
    "id": "wizard-de-creación--edición-en-3-pasos",
    "content": "Wizard de creación / edición en 3 pasos"
  }, {
    "id": "tipo-y-modo-dos-selectores-independientes",
    "content": "Tipo y Modo: dos selectores independientes"
  }, {
    "id": "combos-rediseñados",
    "content": "Combos rediseñados"
  }, {
    "id": "productos-sin-categoría",
    "content": "Productos \"Sin categoría\""
  }, {
    "id": "reservas",
    "content": "Reservas"
  }, {
    "id": "carta-digital",
    "content": "Carta digital"
  }, {
    "id": "mesas",
    "content": "Mesas"
  }, {
    "id": "permisos-y-roles",
    "content": "Permisos y roles"
  }, {
    "id": "modales",
    "content": "Modales"
  }, {
    "id": "accesibilidad-y-legibilidad",
    "content": "Accesibilidad y legibilidad"
  }, {
    "id": "faki-asistente-ia",
    "content": "Faki (asistente IA)"
  }, {
    "id": "aviso-de-nueva-versión",
    "content": "Aviso de nueva versión"
  }, {
    "id": "centro-de-documentación",
    "content": "Centro de documentación"
  }, {
    "id": "tour-guiado-por-rol",
    "content": "Tour guiado por rol"
  }, {
    "id": "temas",
    "content": "Temas"
  }, {
    "id": "otros",
    "content": "Otros"
  }]
};
import {ChangelogHeader} from "@/components/docs/ChangelogHeader";
export let toc = [{
  depth: 2,
  url: "#resumen",
  title: _jsx(_Fragment, {
    children: "Resumen"
  })
}, {
  depth: 2,
  url: "#navegación-en-celular",
  title: _jsx(_Fragment, {
    children: "Navegación en celular"
  })
}, {
  depth: 2,
  url: "#arrastrar-y-soltar",
  title: _jsx(_Fragment, {
    children: "Arrastrar y soltar"
  })
}, {
  depth: 2,
  url: "#pedidos-en-mesa",
  title: _jsx(_Fragment, {
    children: "Pedidos en mesa"
  })
}, {
  depth: 2,
  url: "#corregir-pedido",
  title: _jsx(_Fragment, {
    children: "Corregir pedido"
  })
}, {
  depth: 2,
  url: "#caja-y-crédito-fiado",
  title: _jsx(_Fragment, {
    children: "Caja y crédito (fiado)"
  })
}, {
  depth: 2,
  url: "#facturación-y-tickets",
  title: _jsx(_Fragment, {
    children: "Facturación y tickets"
  })
}, {
  depth: 2,
  url: "#productos",
  title: _jsx(_Fragment, {
    children: "Productos"
  })
}, {
  depth: 3,
  url: "#wizard-de-creación--edición-en-3-pasos",
  title: _jsx(_Fragment, {
    children: "Wizard de creación / edición en 3 pasos"
  })
}, {
  depth: 3,
  url: "#tipo-y-modo-dos-selectores-independientes",
  title: _jsx(_Fragment, {
    children: "Tipo y Modo: dos selectores independientes"
  })
}, {
  depth: 2,
  url: "#combos-rediseñados",
  title: _jsx(_Fragment, {
    children: "Combos rediseñados"
  })
}, {
  depth: 2,
  url: "#productos-sin-categoría",
  title: _jsx(_Fragment, {
    children: "Productos \"Sin categoría\""
  })
}, {
  depth: 2,
  url: "#reservas",
  title: _jsx(_Fragment, {
    children: "Reservas"
  })
}, {
  depth: 2,
  url: "#carta-digital",
  title: _jsx(_Fragment, {
    children: "Carta digital"
  })
}, {
  depth: 2,
  url: "#mesas",
  title: _jsx(_Fragment, {
    children: "Mesas"
  })
}, {
  depth: 2,
  url: "#permisos-y-roles",
  title: _jsx(_Fragment, {
    children: "Permisos y roles"
  })
}, {
  depth: 2,
  url: "#modales",
  title: _jsx(_Fragment, {
    children: "Modales"
  })
}, {
  depth: 2,
  url: "#accesibilidad-y-legibilidad",
  title: _jsx(_Fragment, {
    children: "Accesibilidad y legibilidad"
  })
}, {
  depth: 2,
  url: "#faki-asistente-ia",
  title: _jsx(_Fragment, {
    children: "Faki (asistente IA)"
  })
}, {
  depth: 2,
  url: "#aviso-de-nueva-versión",
  title: _jsx(_Fragment, {
    children: "Aviso de nueva versión"
  })
}, {
  depth: 2,
  url: "#centro-de-documentación",
  title: _jsx(_Fragment, {
    children: "Centro de documentación"
  })
}, {
  depth: 2,
  url: "#tour-guiado-por-rol",
  title: _jsx(_Fragment, {
    children: "Tour guiado por rol"
  })
}, {
  depth: 2,
  url: "#temas",
  title: _jsx(_Fragment, {
    children: "Temas"
  })
}, {
  depth: 2,
  url: "#otros",
  title: _jsx(_Fragment, {
    children: "Otros"
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    ol: "ol",
    p: "p",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(ChangelogHeader, {
      version: "0.3.1-beta",
      date: "2026-05-13",
      tag: "Más reciente"
    }), "\n", _jsx(_components.h2, {
      id: "resumen",
      children: "Resumen"
    }), "\n", _jsx(_components.p, {
      children: "Esta versión está enfocada en hacer Orkestria más cómodo en celular, más rápido para operar y más fácil de aprender. También estrenamos el centro de documentación que estás leyendo, con un asistente Faki integrado, una guía interactiva por rol y bastantes pulidos de QA."
    }), "\n", _jsx(_components.h2, {
      id: "navegación-en-celular",
      children: "Navegación en celular"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Nueva barra inferior"
        }), " con tus 4 accesos directos favoritos siempre a la mano."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Personaliza tus accesos directos"
        }), " desde ", _jsx(_components.code, {
          children: "Perfil → Preferencias UI"
        }), " o manteniendo presionado el botón ", _jsx(_components.code, {
          children: "Más"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Atajos agrupados"
        }), ": el botón ", _jsx(_components.code, {
          children: "Tomar pedido"
        }), " despliega opciones para mesa o domicilio. El botón ", _jsx(_components.code, {
          children: "Cobrar"
        }), " también despliega opciones según el tipo de orden."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Tus preferencias te siguen entre dispositivos"
        }), ": si cambias de celular o de computador, tu configuración se conserva."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Tres modos de navegación móvil"
        }), ": barra inferior, menú hamburguesa, o ambos al mismo tiempo (por defecto)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cierra el menú deslizando hacia abajo"
        }), " con un gesto natural."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Búsqueda en el menú"
        }), " con botón para borrar lo escrito de un toque."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Vuelve arriba automáticamente"
        }), " cuando cambias de sección."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El footer ya no queda tapado"
        }), " por la barra inferior al hacer scroll hasta el final en celular."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "arrastrar-y-soltar",
      children: "Arrastrar y soltar"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Más cómodo de usar en celular"
        }), ": el sistema espera un instante antes de empezar a arrastrar, así no interrumpe el scroll normal."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El elemento que arrastras sigue tu dedo con precisión"
        }), ", sin desfasarse."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Scroll automático"
        }), " cuando arrastras hacia los bordes de la pantalla, incluso entre paneles distintos (por ejemplo, al asignar productos a días en el horario semanal)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Sin selección de texto accidental"
        }), " al mantener presionado un elemento."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "pedidos-en-mesa",
      children: "Pedidos en mesa"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Comensales por grupo"
        }), ": al iniciar una segunda ronda, el contador ya no se vuelve a sumar. Cada grupo de la mesa lleva su propio número de comensales."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Controles rápidos de comensales"
        }), " con botones ", _jsx(_components.code, {
          children: "−"
        }), " y ", _jsx(_components.code, {
          children: "+"
        }), ", y un indicador en formato ", _jsx(_components.code, {
          children: "{seleccionados}/{disponibles}"
        }), ", restando los asientos ocupados por otros grupos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cambio fluido entre grupos"
        }), ": al elegir un grupo existente, se restauran sus comensales; al crear un grupo nuevo, el contador arranca limpio."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Los descuentos del día se aplican correctamente"
        }), " al agregar productos a una orden."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cliente \"Nuevo cliente\" directo en el selector"
        }), ": al tomar pedido, tomar domicilio o cobrar, ya no tienes que cambiar de sección para registrar un cliente nuevo. Lo creas en un modal rápido y queda seleccionado automáticamente."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "corregir-pedido",
      children: "Corregir pedido"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Rondas separadas por grupo"
        }), ": cuando una mesa tiene varios grupos, las rondas se cuentan dentro de cada grupo, no en una sola lista."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Selector de grupo tipo pestaña"
        }), " arriba del listado para alternar entre los grupos activos de la mesa."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Indicador de qué grupo estás viendo"
        }), " (\"Mostrando Grupo X · N rondas · M comensales\") para que no haya duda."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Puedes volver a aumentar la cantidad de un producto desde cero"
        }), " cuando corriges una orden."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Aviso a cocina al corregir un pedido"
        }), ": si modificas un producto que va a cocina, el chef se entera."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "caja-y-crédito-fiado",
      children: "Caja y crédito (fiado)"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "No se puede cerrar la mesa hasta que todas las rondas estén entregadas"
        }), ": incluso si se hizo precobro, el sistema espera a que cocina + mesero terminen para evitar cobrar comida que no llegó."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Pre-cobro a crédito ahora cierra correctamente"
        }), ": al confirmar el cierre, la deuda queda registrada en la cuenta del cliente automáticamente."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Selector \"Nuevo cliente\" inline"
        }), " en ", _jsx(_components.code, {
          children: "Cobrar orden"
        }), " y ", _jsx(_components.code, {
          children: "Cobrar domicilio"
        }), ", tanto al asignar cliente a la orden como al cargar a cuenta de crédito."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Facturación de grupos separada"
        }), ": al cobrar mesas con varios grupos, cada grupo genera su propia factura/visita en ", _jsx(_components.code, {
          children: "Órdenes completadas"
        }), ". Antes se mezclaban los pedidos en una sola factura."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cobro mixto de grupos en la misma mesa"
        }), ": ya puedes cobrar un grupo a crédito y otro con tarjeta/efectivo sin que el sistema confunda los grupos. Los grupos ya cargados a crédito dejan de bloquear el cobro de los grupos restantes."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "facturación-y-tickets",
      children: "Facturación y tickets"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Adiciones y observaciones con cargo aparecen en factura, ticket y correo"
        }), ": cada extra que el cliente pidió (queso adicional, salsas, etc.) y las observaciones con costo se muestran como sub-líneas indentadas debajo del producto base. Ahora la suma de líneas coincide con el total cobrado."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Métodos de pago con etiquetas claras"
        }), ": ya no se muestra ", _jsx(_components.code, {
          children: "credit"
        }), " ni ", _jsx(_components.code, {
          children: "mixed"
        }), " en inglés. Se ve \"A cuenta del cliente\" y \"Pago mixto\" en facturas, tickets y correos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Pago mixto desglosado"
        }), ": cuando un cobro se divide en dos métodos (ej. parte efectivo + parte tarjeta), la factura y el correo muestran cada método con su monto. Antes el correo enviaba un código de programación crudo."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Correo de factura completo"
        }), ": cuando una visita tiene varias rondas, el correo enviado al cliente incluye TODAS las rondas como una sola factura combinada. Antes solo se enviaba la primera ronda."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Rondas separadas visualmente en factura combinada"
        }), ": cuando una visita tiene varias rondas, la factura, el ticket térmico y el correo muestran un encabezado \"Ronda N · fecha/hora\" antes de los productos de cada una. Así se distingue claramente qué se pidió en cada momento."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "productos",
      children: "Productos"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Acciones del producto agrupadas"
        }), " en un solo botón con menú: editar, programar días, gestionar adiciones, eliminar y más, sin saturar la fila."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Aviso visual de stock bajo o agotado"
        }), " directamente en la lista."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Adiciones"
        }), " se refresca al instante después de crearlas o editarlas (antes había que recargar)."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "wizard-de-creación--edición-en-3-pasos",
      children: "Wizard de creación / edición en 3 pasos"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Nuevo flujo en 3 pasos"
        }), " con barra de progreso visible:", "\n", _jsxs(_components.ol, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Información"
            }), ": datos del producto (Tipo, Modo, nombre, precio, etc.)."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Combo"
            }), ": selección de componentes — solo aparece si el tipo es \"Combo\"."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Multimedia"
            }), ": galería de imágenes y videos."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El paso 2 se omite automáticamente"
        }), " para productos individuales."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Botón \"Crear producto\" / \"Guardar cambios\" deshabilitado"
        }), " hasta completar todos los pasos válidos (campos requeridos + ≥1 componente si es combo). Ya no es posible enviar formularios incompletos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Navegación libre hacia atrás"
        }), " para corregir cualquier paso."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "tipo-y-modo-dos-selectores-independientes",
      children: "Tipo y Modo: dos selectores independientes"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["El selector único \"Tipo\" se separa en ", _jsx(_components.strong, {
          children: "dos campos"
        }), ":", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Tipo"
            }), ": ", _jsx(_components.code, {
              children: "Producto"
            }), " / ", _jsx(_components.code, {
              children: "Combo"
            }), " — define si se compone de otros productos o no."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Modo"
            }), ": ", _jsx(_components.code, {
              children: "Preparado"
            }), " / ", _jsx(_components.code, {
              children: "Bajo pedido"
            }), " — define si requiere pasar por cocina."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Los combos también pueden ser \"bajo pedido\""
        }), ": antes los combos siempre se trataban como preparados."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El enrutamiento a cocina"
        }), " ahora considera el modo del combo + el modo de cada componente: si alguno requiere cocina, la orden pasa por cocina."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "combos-rediseñados",
      children: "Combos rediseñados"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El combo se compone de otros productos"
        }), ": al crearlo defines qué productos lo integran y cuántas unidades de cada uno. Antes el combo era un producto suelto sin componentes reales."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Stock automático y en cascada"
        }), ": el stock del combo se calcula a partir del stock de sus componentes. Por ejemplo, si un combo lleva 2× Hamburguesa y quedan 10 hamburguesas, el combo \"Alcanza para 5\"."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Al pedir un combo se descuenta a los componentes"
        }), ", no al combo. Si un mismo producto está en un combo y también como producto suelto en la misma orden, se suma y valida una sola vez contra el stock real."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Sin anidación"
        }), ": un combo no puede contener a otro combo (mantiene la lógica clara)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "No se puede crear un combo vacío"
        }), ": el sistema te exige al menos un componente antes de guardar."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Restauración al cancelar"
        }), ": si una orden con combos se cancela, los componentes recuperan su stock correctamente (antes solo se restauraba el combo)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Badge \"Combo\""
        }), " visible en la carta digital junto al nombre, con prioridad ", _jsx(_components.code, {
          children: "Agotado > Combo > Popular"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Composición visible en la carta"
        }), ": debajo de la descripción se lista \"Incluye: 2× Hamburguesa, 1× Papas, 1× Bebida\". La vista de detalle muestra una sección dedicada \"Este combo incluye\"."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Agotado de combo automático"
        }), ": si un componente con control de stock se acaba, el combo aparece como \"Agotado\" sin acción manual."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "productos-sin-categoría",
      children: "Productos \"Sin categoría\""
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Ya no se publican en la carta digital"
        }), ". Esta sección queda como espacio interno para borradores u organización temporal."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Aviso visual en el dashboard"
        }), ": la sección \"Sin categoría\" del constructor de menú muestra una etiqueta \"No se muestra en la carta\" para evitar confusión."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Para publicar un producto"
        }), " debes asignarle una categoría existente o crear una nueva."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "reservas",
      children: "Reservas"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Los meseros ya pueden arrastrar reservas"
        }), " entre días, no solo dueños y administradores."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "\"Nuevo cliente\" inline"
        }), " también disponible al editar una reserva, para no salir del flujo."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "carta-digital",
      children: "Carta digital"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Vista previa instantánea"
        }), " al activar la carta: ya no hay que esperar a que el caché se renueve para verla."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Recomendaciones visibles"
        }), " al subir el banner (relación 21:9, resolución sugerida, formatos, tamaño máximo) para evitar imágenes mal recortadas."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Código QR con el logo Orkestria al centro"
        }), ", ahora visible en todos los temas."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "mesas",
      children: "Mesas"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Crear o cambiar de zona"
        }), " desde el formulario ya no cierra el modal por accidente al interactuar con el selector."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "permisos-y-roles",
      children: "Permisos y roles"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Meseros pueden crear clientes"
        }), " directamente desde la lista o desde el selector inline en pedidos/reservas."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Dueño sin restricciones"
        }), ": arreglado el caso en que un dueño no podía abrir caja, eliminar invitaciones u operar acciones administrativas porque el sistema no lo reconocía como miembro de su propio restaurante. Ahora se le asigna automáticamente como dueño en el primer acceso."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "modales",
      children: "Modales"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Modales más cómodos en celular"
        }), ": el contenido largo ahora puede desplazarse sin romper el diseño."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El fondo del modal bloquea correctamente"
        }), " la interacción con la página detrás; ya no se puede hacer scroll por accidente."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Los menús desplegables dentro de un modal"
        }), " (selectores, combobox, etc.) ya no lo cierran al hacer clic dentro."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El menú hamburguesa no abre el teclado"
        }), " al abrirse."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "accesibilidad-y-legibilidad",
      children: "Accesibilidad y legibilidad"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Nuevo ajuste de tamaño de texto"
        }), ": si el texto te parece pequeño, puedes elegir entre 4 tamaños — Compacto, Normal, Grande y Extra grande — y todo el dashboard escala de manera proporcional (texto, botones, espaciados)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Wizard de bienvenida"
        }), ": la primera vez que entras al dashboard, Orkestria te pregunta qué tamaño de texto prefieres con una vista previa en vivo. Después no vuelve a aparecer."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cámbialo cuando quieras"
        }), " desde ", _jsx(_components.code, {
          children: "Perfil → Preferencias UI → Legibilidad"
        }), ". Tu elección queda guardada y te sigue entre dispositivos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Vista previa en vivo"
        }), ": mientras eliges, ves un ejemplo real de cómo quedará la interfaz (nombre de producto, descripción, stock, botón), así sabes lo que estás aplicando antes de confirmar."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Pestaña dedicada en perfil"
        }), ": la sección antes llamada \"Preferencias UI\" ahora se llama ", _jsx(_components.strong, {
          children: "\"Accesibilidad e interfaz\""
        }), " para que sea fácil de encontrar."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Encabezados del menú lateral más claros"
        }), ": los títulos de grupo (MENÚ, CAJA, etc.) tienen tamaño fijo y un separador superior, así no se confunden con las pestañas — sobre todo cuando usas tamaños de texto grandes."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "faki-asistente-ia",
      children: "Faki (asistente IA)"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "En celular, el chat se hace pequeño cuando Faki te muestra un resultado"
        }), ", para que veas lo que hizo."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El botón flotante de Faki ya no tapa la barra inferior"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "La guía visual se cancela automáticamente"
        }), " si te vas a otra sección de la app durante el proceso. Antes Faki seguía intentando avanzar sobre la pantalla nueva."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Faki ya sabe crear combos"
        }), ": puedes pedirle \"crea un combo X con 2 hamburguesas y 1 papas\" y Faki lo arma con los componentes existentes. Si falta info, te la pregunta antes de invocar. Antes solo sabía crear productos individuales."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Editar componentes de un combo desde el chat"
        }), ": nueva acción ", _jsx(_components.code, {
          children: "setComboItems"
        }), " permite a Faki cambiar, añadir o quitar productos de un combo ya creado, conservando todas las validaciones (mínimo 1 componente, sin combos anidados, sin auto-referencia)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Modo de preparación independiente del tipo"
        }), ": Faki ahora distingue claramente entre \"producto vs combo\" y \"preparado vs bajo pedido\". Puede crear un combo que requiera cocina, o uno listo para servir, según le pidas."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Fix de bucle infinito al marcar tareas"
        }), ": ocasionalmente Faki entraba en un loop intentando marcar una tarea con un ID que no existía en su lista — el sistema decía \"✓\" en verde pero la tarea no avanzaba. Ahora si el ID no existe, Faki lo sabe al instante y corrige sin reintentar."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Faki conoce el menú completo en una sola llamada"
        }), ": nueva acción ", _jsx(_components.code, {
          children: "listMenu"
        }), " devuelve todas las categorías + productos de un restaurante en una operación. Antes Faki buscaba producto por producto con ", _jsx(_components.code, {
          children: "searchProduct"
        }), ", lo que era lento y propenso a duplicados. Ahora cuando le pides crear un menú o auditar el catálogo, primero ve qué existe y evita duplicar."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Faki no repite lecturas innecesarias"
        }), ": cuando Faki emite varias veces la misma consulta (ej. dos ", _jsx(_components.code, {
          children: "listMenu"
        }), " con los mismos argumentos en la misma respuesta), el sistema deduplica antes de ejecutar — verás una sola tarjeta de actividad en el chat en lugar de varias. Si Faki insiste, tras 3 intentos recibe un STOP forzoso para que avance con lo que ya tiene."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "aviso-de-nueva-versión",
      children: "Aviso de nueva versión"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Modal \"Qué hay de nuevo\""
        }), ": cuando se actualiza Orkestria, te aparece una sola vez un aviso con un resumen del cambio y un botón ", _jsx(_components.strong, {
          children: "Ver cambios"
        }), " que te lleva directo al changelog."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Una vez por versión, por usuario"
        }), ": lo cierras una vez y ya no vuelve a aparecer hasta la próxima release."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Usuarios nuevos no se molestan"
        }), ": si entras por primera vez, solo ves el wizard de accesibilidad — el aviso de versión se omite para no acumular interrupciones."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "centro-de-documentación",
      children: "Centro de documentación"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: ["Sección dedicada en ", _jsx(_components.code, {
            children: "/docs"
          })]
        }), " con changelogs y manual de usuario, accesible para todos (no requiere iniciar sesión)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Accesos desde toda la plataforma"
        }), ": enlace en el landing, footer y dentro del dashboard."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Selector de versiones"
        }), " para ver el detalle completo de cada release."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cambio de tema dentro de docs"
        }), " (claro, azul oscuro, noche): se sincroniza con el resto de la plataforma."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Asistente Faki integrado en docs"
        }), ":", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Conoce toda la documentación"
            }), " y responde tus dudas en español con Markdown (negritas, listas, secciones)."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Page-agent"
            }), ": te lleva al lugar exacto de la respuesta. Resalta la sección concreta con un anillo visual."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Dos modos"
            }), ": flotante (sobre el contenido) o inmersivo (empuja el contenido a un lado, configurable y redimensionable)."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Abierto por defecto"
            }), " en computador, cerrado por defecto en celular."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Límite por dispositivo"
            }), ": 10 consultas al día, sin afectar tu cuota de Faki en el resto de la app."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "tour-guiado-por-rol",
      children: "Tour guiado por rol"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Primera vez que entras a un restaurante con un rol nuevo"
        }), ": Faki te ofrece una guía rápida con paso a paso interactivo (resaltado, tooltips, navegación entre pestañas)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Por rol"
        }), ": dueño, administrador, mesero, chef, cajero, encargado de domicilios y encargado de inventario tienen tours adaptados a lo esencial de su trabajo."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Se muestra una sola vez por rol"
        }), ", aunque pertenezcas a varios restaurantes."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Si lo saltas, no vuelve a aparecer"
        }), ", pero siempre puedes preguntarle a Faki para repasarlo."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "temas",
      children: "Temas"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Tema noche corregido en facturación"
        }), " y otras zonas que se veían en blanco sobre blanco."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El cambio de tema se sincroniza"
        }), " entre el landing, la app y el centro de documentación."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "otros",
      children: "Otros"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Video del landing"
        }), " ya no se solapa con la barra superior en celular."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Programar días de disponibilidad"
        }), " de un producto desde su menú de acciones."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Acceso desde red local"
        }), ": la app se puede probar desde otro dispositivo en la misma red sin configurar nada extra."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Redirección automática al expirar la sesión"
        }), ": si el token caduca mientras usas el dashboard, te enviamos al login con un aviso \"Tu sesión expiró\". Antes solo aparecía un error 401 silencioso."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Vuelta al inicio en navegación interna"
        }), ": cuando un tab tiene flujo en pasos (cobrar mesa, cobrar domicilio, corregir pedido, tomar pedido, tomar domicilio, sesiones de caja, órdenes completadas, cuentas de crédito), al avanzar o retroceder de pantalla la página vuelve arriba automáticamente. Antes quedabas mirando el footer y daba sensación de estar perdido."]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
